import { createFileRoute } from '@tanstack/react-router';
import TurnReportEdit from '~/containers/TurnReportEdit';

export const Route = createFileRoute('/turn-reports/$turnReportId')({
  component: TurnReportEdit,
  validateSearch(search) {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
